'use client';

import React from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * Modern floating Toast component for quick non-blocking feedback.
 * Adheres to Clean Mode aesthetics (flat surfaces, subtle borders, concise microcopy).
 *
 * @param {Object} props
 * @param {boolean} props.open - Controls visibility
 * @param {Function} props.onClose - Callback on autoHide or manual close
 * @param {string} props.message - Short concise message (e.g. "Guardado", "Subasta creada")
 * @param {string} [props.severity='success'] - 'success' | 'error' | 'warning' | 'info'
 * @param {number} [props.autoHideDuration=2500] - Duration in ms
 * @param {Object} [props.anchorOrigin={ vertical: 'top', horizontal: 'center' }] - Position on screen
 */
const Toast = ({
  open,
  onClose,
  message,
  severity = 'success',
  autoHideDuration = 2500,
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
}) => {
  if (!message) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      sx={{
        zIndex: (theme) => theme.zIndex.tooltip + 10,
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        elevation={0}
        sx={{
          borderRadius: 2.5,
          px: 2.5,
          py: 0.85,
          fontSize: '0.92rem',
          fontWeight: 600,
          alignItems: 'center',
          letterSpacing: '-0.01em',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
          ...(severity === 'success' && {
            bgcolor: '#10B981', // Verde esmeralda moderno
            color: '#FFFFFF',
            '& .MuiAlert-icon': {
              color: '#FFFFFF',
            },
          }),
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
